module.exports = require("npm:in-view@0.6.0/dist/in-view.min.js");